import { Button, StandardDialog } from "@roc/ui";
import { observer } from "mobx-react";
import { useBaseStore } from "@roc/feature-app-core";
import { useDocumentStore } from "@roc/feature-documents";
import { Grid } from "@material-ui/core";
import { ServicerProvidedData } from "./servicerProvidedData";
import { useEffect } from "react";
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

export type ServicerProvidedDataDialogProps = {
  open: boolean;
  loan: any;
  onClose: () => void;
  document: Document;
};

export const ServicerProvidedDataDialog = observer((props: ServicerProvidedDataDialogProps) => {
  const { open, loan, onClose, document } = props;
  const { globalStore } = useBaseStore();

  const {
    documentStore: {
      documentFormStore: { servicerProvidedDataStore },
    },
  } = useDocumentStore();
  const taskId = document?.taskId;

  useEffect(() => {
    if (open) {
      servicerProvidedDataStore.reset();
      servicerProvidedDataStore.getPayoffData(loan);
    }
  }, [open]);

  const onSubmit = () => {
    servicerProvidedDataStore.submitServicerProvidedData();
    onClose();
  };

  const dialogActions = (<Grid container spacing={1} justifyContent="flex-end">
    <Grid item>
      <Button
        onClick={onClose}
        color="primary"
        variant="outlined"
        testId="cancel"
      >
        Cancel
      </Button>
    </Grid>
    <Grid item>
      <Button
        onClick={onSubmit}
        color="primary"
        variant="contained"
        testId="confirm"
        disabled={false}
      >
        Save
      </Button>
    </Grid>
  </Grid>)

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Payoff Request Details"
          handleClose={onClose}
          dialogContent={<ServicerProvidedData store={servicerProvidedDataStore} />}
          dialogActions={dialogActions}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Payoff Request Details"
          maxWidth="lg"
          handleClose={onClose}
          dialogContent={<ServicerProvidedData store={servicerProvidedDataStore} />}
          dialogActions={dialogActions}
        />
      )}
    </>


  );
});

export default ServicerProvidedDataDialog;